import {UILobbyController} from '../../../shared/scripts/ui_html/lobby/UILobbyController'
import {UIRoomController} from './room/UIRoomController'
import {UISceneController} from './UISceneController'
import {UIWAdController} from '../ui_ad/UIWAdController'
import {UIUrlController, UIUrlParameterNames} from '../../../shared/scripts/ui_html/UIUrlController'
import {UIWHeaderController} from './header/UIWHeaderController'
import {UIWLandingPageController} from './landing_page/UIWLandingPageController'
import {UIWFooterController} from './UIWFooterController'
import {UIMatchmakingFindGameController} from '../ui_matchmaking/UIMatchmakingFindGameController'
import {UIVLIController} from '../../../shared/scripts/ui_ad/UIVLIController'
import {UIMainPageController} from './main_page/UIMainPageController'
import {Scene} from './UISceneTypes'
import {UIUtilsEjsVariables} from '../../../shared/scripts/UIUtilsEjsVariables'
import {UIDHeaderController} from './header/UIDHeaderController'
import {UIDFooterController} from './UIDFooterController'
import {UIDLandingPageController} from './landing_page/UIDLandingPageController'
import {UIWManagerEvents} from './UIWManagerEvents'
import {UIDManagerEvents} from './UIDManagerEvents'
import {UIDiscordSceneController} from '../discord/child_iframe/UIDiscordSceneController'
import {getHomepageUrlWithParameter, navigateToPage} from '../../../shared/scripts/ui_utils/ClientUtils'
import {UIEntryUrlParameterController} from '../../../shared/scripts/UIEntryUrlParameterController'

export class UIManager {
    uiManagerEvents: UIWManagerEvents
    header: UIWHeaderController
    footer: UIWFooterController

    landingPage: UIWLandingPageController
    lobby: UILobbyController
    mainPage: UIMainPageController
    room: UIRoomController
    sceneController: UISceneController
    adController: UIWAdController
    urlController: UIUrlController
    matchmakingController: UIMatchmakingFindGameController
    vliController: UIVLIController | undefined
    homepageSceneContainer: HTMLDivElement
    discordSceneController: UIDiscordSceneController | undefined

    constructor() {
        this.uiManagerEvents = UIUtilsEjsVariables.isUserOnDiscord ? new UIDManagerEvents(this) : new UIWManagerEvents(this)
        this.header = UIUtilsEjsVariables.isUserOnDiscord ? new UIDHeaderController() : new UIWHeaderController()
        this.footer = UIUtilsEjsVariables.isUserOnDiscord ? new UIDFooterController() : new UIWFooterController()
        this.landingPage = UIUtilsEjsVariables.isUserOnDiscord ? new UIDLandingPageController(this) : new UIWLandingPageController(this)

        this.lobby = new UILobbyController()
        this.mainPage = new UIMainPageController(this)
        this.room = new UIRoomController(this)
        this.adController = new UIWAdController()
        this.urlController = new UIUrlController()
        this.matchmakingController = new UIMatchmakingFindGameController(this)
        this.vliController = UIUtilsEjsVariables.isUserOnDiscord ? undefined : new UIVLIController()
        this.discordSceneController = UIUtilsEjsVariables.isUserOnDiscord ? new UIDiscordSceneController(this.header, this.footer) : undefined
        this.homepageSceneContainer = document.getElementById('scene_homepage_container') as HTMLDivElement
        this.sceneController = new UISceneController(this)
        this.setHeaderNavActions()
    }

    init() {
        this.matchmakingController.init()
    }

    // eslint-disable-next-line class-methods-use-this
    clearDOM() {
        const mainContainer = document.getElementById('main_container')
        if(mainContainer != undefined) mainContainer.remove()
    }

    private setHeaderNavActions() {
        if(!(this.header instanceof UIWHeaderController)) return
        const navHeaderHomeButtonAction = (event: MouseEvent) => {
            const acceptedScenes = [Scene.LandingPage, Scene.Lobby, Scene.MainPage]
            const alreadyOnMainpage = acceptedScenes.includes(this.sceneController.scene)
            if(!alreadyOnMainpage) return
            event.preventDefault()
            this.sceneController.loadScene(Scene.MainPage)
        }
        this.header.setHomeButtonAction(navHeaderHomeButtonAction)

        const navHeaderLobbyButtonAction = (event: MouseEvent) => {
            const acceptedScenes = [Scene.LandingPage, Scene.Lobby, Scene.MainPage]

            if(this.sceneController.scene == Scene.Room) {
                this.room.leaveRoom()
                return
            }

            const alreadyOnMainpage = acceptedScenes.includes(this.sceneController.scene)
            if(!alreadyOnMainpage) {
                navigateToPage(getHomepageUrlWithParameter(UIUrlParameterNames.Lobby, UIEntryUrlParameterController.DEFAULT_PARAMETER_VALUE))
                return
            }
            event.preventDefault()
            this.sceneController.loadScene(Scene.Lobby)
        }
        this.header.setLobbyButtonAction(navHeaderLobbyButtonAction)
    }
}
